import { Feature } from '@yandex/ymaps3-types/packages/clusterer';

import { styles } from './Cluster.styles';

interface ClusterProps {
  features: Feature[];
  onClick: (features: Feature[]) => void;
}

export function Cluster({ features, onClick }: ClusterProps) {
  const slots = styles();

  return (
    <button
      className={slots.cluster()}
      onClick={() => onClick(features)}
    >
      <span className={slots.count()}>{features.length}</span>
    </button>
  );
}
